<template>
  <div>
      <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
        <el-button type="primary" size="mini" @click="addProductDialog()">
          添加
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column prop="object_id" label="ID" align="center" min-width="6%"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
          min-width="20%"
        ></el-table-column>
        <el-table-column label="图片" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <el-button
              type="danger"
              size="mini"
              @click="productRecommendDeleteProduct(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <!-- 商品推荐添加商品 -->
    <el-dialog
      title="选择商品"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="small"
            v-model="search.query.search"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              searchData();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
        border
        ref="multipleTable"
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
      <div style="margin-top: 20px">
        <el-button @click="productRecommendAddProduct()"
          >确定</el-button
        >
        <el-button @click="toggleSelection()">取消选择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { flashSaleProductScreen } from "@/api/promotion";

import {
  productRecommendList,
  productRecommendAddProduct,
  productRecommendDeleteProduct
} from "@/api/mall";

export default {
  data: function () {
    return {
      ossAction: "",
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      updateLoading: false,
      query: {
        id: this.$route.query.id,
        page: 1,
        limit: 20,
      },
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          search: "",
          page: 1,
          limit: 5,
        },
        result: {
          total: 0,
          data: [],
        },
      },
      addProduct: {
          id: this.$route.query.id,
          productIds: []
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    addProductDialog() {
        this.addProduct.productIds = [];
        this.search.chooseOrgVisible = true;
        this.searchData();
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.search = "";
      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
      this.addProduct.productIds = [];
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      flashSaleProductScreen(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    handleSelectionChange(rows) {
        this.addProduct.productIds = [];
        rows.forEach(row => {
            this.addProduct.productIds.push(row.id);
        });
    },
    productRecommendAddProduct() {
        productRecommendAddProduct(this.addProduct)
        .then((response) => {
          this.updateLoading = false;
          if (response.status == 2000) {
            this.$message.success(response.message);
            this.addEditFormOnClose();
            this.getList();
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    getList() {
      this.loading = true;
      productRecommendList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    productRecommendDeleteProduct(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        productRecommendDeleteProduct({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
}
</script>

<style>

</style>